// JSON proxies for the check-in insights panel (sc-47708). The panel polls
// while the coach's AI works, so these answer JSON instead of refreshing.
// Endpoints: msb-api lib/api/checkin-insights (sc-47706).

const forward = async ({ res, api }, path: string, options = {}) => {
  res.headers = res.headers || {};
  res.headers["Content-Type"] = "application/json; charset=utf-8";
  try {
    const response = await api(path, options);
    res.status = response.status;
    res.body = (await response.text()) || "{}";
  } catch (error) {
    res.status = 500;
    res.body = JSON.stringify({ error: error.message || "Request failed" });
  }
};

// A real JSON body, so the API doesn't castJSON bullet text ("No", "5").
const jsonBody = (body: unknown) => ({
  body: JSON.stringify(body),
  headers: { "Content-Type": "application/json" },
});

const checkinPath = (checkinId: string) =>
  `checkins/${encodeURIComponent(checkinId)}`;

const CheckinInsights = (app) => {
  app.get("/checkin-insights/connections", (ctx) =>
    forward(ctx, "coach/ai-connections")
  );

  app.get("/checkin-insights/:checkinId", (ctx) =>
    forward(ctx, `${checkinPath(ctx.req.params.checkinId)}/insight`)
  );

  app.post("/checkin-insights/:checkinId/requests", (ctx) =>
    forward(ctx, `${checkinPath(ctx.req.params.checkinId)}/insight-requests`, {
      method: "POST",
      ...jsonBody({ provider: ctx.req.body?.provider }),
    })
  );

  app.delete("/checkin-insights/:checkinId/requests/:requestId", (ctx) =>
    forward(
      ctx,
      `${checkinPath(ctx.req.params.checkinId)}/insight-requests/${encodeURIComponent(ctx.req.params.requestId)}`,
      { method: "DELETE" }
    )
  );

  // `content` arrives JSON-encoded: our body parser casts every field.
  app.patch("/checkin-insights/:checkinId", (ctx) =>
    forward(ctx, `${checkinPath(ctx.req.params.checkinId)}/insight`, {
      method: "PATCH",
      ...jsonBody({
        section: ctx.req.body?.section,
        content: ctx.req.body?.content,
      }),
    })
  );
};

export default CheckinInsights;
